import axios from "@/common/axios";

// 登录
export const login = (params) => {
  // params.password = md5(params.password).toUpperCase()
  return axios.post("/page/register/login", params);
};
//注册
export const reg = (params) => {
  return axios.post("/page/register/insertRegister", params);
};
//验证码
export const getyzm = (params) => {
  return axios.post("/page/register/SendMsg", params);
};
//重置密码
export const uppassword = (params) => {
  return axios.post("/page/register/updatePassWord", params);
};
//首页查询
export const show = (params) => {
  return axios.get("/page/homePageData" + "?userId=" + params.id);
};
//获取学校列表
export const getschool = (params) => {
  return axios.get("/page/getSchoolList");
};
//获取派出所列表
export const getpolice = (params) => {
  return axios.get("/page/getPoliceList");
};
//查询该学生是否重复填报
export const selectByIdCard = (params) => {
  return axios.get(
    "/page/selectByIdCard" +
      "?idCard=" +
      params.idno +
      "&loginUserId=" +
      params.id
  );
};

//查询该学生是否已经填写过
export const getidno = (params) => {
  return axios.get("/page/getEnrollment", { params });
};
//查询审核驳回原因
export const getbhyy = (params) => {
  return axios.get(
    "/page/selectRejectionReason" + "?userInfoId=" + params.userInfoId
  );
};
//查询完如果无记录保存一下
export const saveuser = (params) => {
  return axios.post("/page/saveUserInfo", params);
};
//删除学生信息
export const deluser = (params) => {
  return axios.post("/page/homePageDelete", params);
};
//上传图片获取图片地址
export const upimg = (params) => {
  return axios.post("/page/uploadMinio", params);
};

//保存户籍信息（第一步）
export const saveone = (params) => {
  return axios.post("/page/saveOne", params);
};
//保存户籍附件信息（第二步）
export const savetwo = (params) => {
  return axios.post("/page/saveTwo", params);
};
//保存房产信息（第三步）
export const savethree = (params) => {
  return axios.post("/page/saveThree", params);
};
//保存学校信息（第四步）
export const savefour = (params) => {
  return axios.post("/page/saveFour", params);
};
//查询户籍信息（第一步）
export const selectone = (params) => {
  return axios.get("/page/selectOne" + "?userInfoId=" + params.userInfoId);
};
//查询户籍附件信息（第二步）
export const selecttwo = (params) => {
  return axios.get("/page/selectTwo" + "?userInfoId=" + params.userInfoId);
};
//查询房产信息（第三步）
export const selectthree = (params) => {
  return axios.get("/page/selectThree" + "?userInfoId=" + params.userInfoId);
};
//查询学校信息（第四步）
export const selectfour = (params) => {
  return axios.get("/page/selectFour" + "?userInfoId=" + params.userInfoId);
};
//保存提交
export const savedata = (params) => {
  return axios.post("/page/saveSubmit", params);
};
